import Vue from 'vue';
import money from 'v-money';

Vue.use(money, {
  thousands: ' ',
  precision: 0,
  masked: false
});
